export default server => ({

    async paginate(page = 1, search = '') {
        let {data} = await server.get(`users?page=${page}&search=${search}`);
        return data;
    },

    async lastRegistrations() {
        let {data} = await server.get(`users/last`);
        return data;
    },
    async saveProfile(id, data) {
        let {res} = await server.patch(`users/${id}`, data);
        return res;
    },

});